import { motion } from "motion/react";
import { Check, X } from "lucide-react";
import { Button } from "./ui/button";

export function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="px-4 py-2 rounded-full bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-600/30 text-purple-600">
            提供終了時の料金プラン
          </span>
          <h2 className="mt-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
            シンプルで明快な料金
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-muted-foreground">
            以下はサービス提供当時の料金です。現在は新規契約を受け付けていません。
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-purple-600 to-blue-600 rounded-3xl p-1"
          >
            <div className="bg-card rounded-3xl p-8 md:p-12">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-3xl mb-2">スタンダードプラン</h3>
                  <div className="flex items-baseline gap-2 mb-6">
                    <span className="text-5xl bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">¥300</span>
                    <span className="text-muted-foreground">/月（税込）</span>
                  </div>
                  <p className="text-muted-foreground mb-6">
                    すべての機能が含まれています。最低利用期間なし、いつでも解約可能。
                  </p>
                  
                  <div className="space-y-2 mb-8">
                    <div className="inline-block bg-gradient-to-r from-green-500/10 to-emerald-500/10 border border-green-500/30 rounded-full px-4 py-2">
                      <span className="text-green-600">初月無料コード：CASHFIRST</span>
                    </div>
                  </div>

                  <Button
                    size="lg"
                    disabled
                    className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white"
                  >
                    2026年3月 サービス終了
                  </Button>

                  <div className="mt-6 space-y-2 text-sm text-muted-foreground">
                    <p>✓ 決済方法：クレジットカード（Stripe）</p>
                    <p>✓ 請求サイクル：毎月自動更新</p>
                    <p>✓ 領収書：Stripeから自動送付</p>
                  </div>
                </div>

                <div>
                  <h4 className="mb-6">含まれる機能</h4>
                  <div className="space-y-3">
                    {[
                      "地図への店舗掲載",
                      "決済方法の表示・更新",
                      "店舗の種類・住所の管理",
                      "ダッシュボードアクセス",
                      "メールサポート",
                    ].map((feature, index) => (
                      <div key={index} className="flex items-center gap-3">
                        <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center">
                          <Check size={14} className="text-white" />
                        </div>
                        <span className="text-foreground">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mt-12 pt-8 border-t border-border">
                <h4 className="mb-4">ROI試算：超簡易計算</h4>
                <div className="bg-muted/30 rounded-xl p-6">
                  <p className="text-sm text-muted-foreground mb-3">
                    例：客単価1,000円の場合、3ヶ月で1人増えたら月300円は回収
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
                    <div className="bg-background/50 rounded-lg p-4">
                      <div className="text-2xl bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">3ヶ月</div>
                      <div className="text-xs text-muted-foreground mt-1">の間に</div>
                    </div>
                    <div className="bg-background/50 rounded-lg p-4">
                      <div className="text-2xl bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">1人</div>
                      <div className="text-xs text-muted-foreground mt-1">新規来店で回収可能</div>
                    </div>
                    <div className="bg-background/50 rounded-lg p-4">
                      <div className="text-2xl bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">¥1,000</div>
                      <div className="text-xs text-muted-foreground mt-1">客単価想定</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-center mt-8 text-sm text-muted-foreground"
          >
            <p>複数店舗の登録も同一メールアドレスから可能です</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
